import React from "react";
import RegisterForm from "../components/register/RegisterForm";

function Register() {
	return <RegisterForm />;
}

export default Register;
